// @ts-nocheck

import React, { useRef, useEffect, useState } from 'react';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import styled from 'styled-components';
import { FaArrowUp } from 'react-icons/fa';
import { gaExperienceButtonClick } from 'utils/google_analytics';

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 15px;
  margin-top: -10px;
  @media screen and (min-width: 600px) {
    display: none;
  }
`;

const BackGroundContainer = styled.div`
  background-color: white;
  padding-bottom: 10px;
  border-radius: 6px;
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;
`;

const ArrowGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const ArrowBtn = styled.button`
  background: white;
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: #f1f1f1;
  }
`;

const ScrollArea = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  border-radius: 6px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const ImageCard = styled.img`
  width: 100%;
  min-width: 100%;
  object-fit: contain;
  background: #000;
  scroll-snap-align: center;
`;
const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 8px;
`;

const Bar = styled.div`
  width: 25px;
  height: 4px;
  border-radius: 2px;
  background: ${(props) => (props.active ? props.color : '#e0e0e0')};
  transition: background 0.3s ease;
`;

export default function HotelInfoScroller({ hotelItems = [], settings }) {
  const scroller = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const scroll = (dir) => {
    const container = scroller.current;
    if (!container) return;

    const amount = container.clientWidth; // one image at a time
    container.scrollBy({
      left: dir === 'left' ? -amount : amount,
      behavior: 'smooth',
    });
  };

  const handleScroll = () => {
    const container = scroller.current;
    if (!container) return;

    const index = Math.round(container.scrollLeft / container.clientWidth);
    setCurrentIndex(index);
  };
  useEffect(() => {
    const container = scroller.current;
    if (!container) return;

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);
  const cardPressHandler = (item) => {
    let firstItemUrl = item?.restaurant_info[0]?.url || item?.url;
    const firstItemLable = item?.restaurant_info[0]?.label;
    if (!firstItemUrl) {
      firstItemUrl = item?.url;
    }

    if (firstItemUrl) {
      window.open(firstItemUrl);
    }
  };
  return (
    <Wrapper>
      <HeaderRow></HeaderRow>

      <BackGroundContainer>
        <ScrollArea ref={scroller}>
          {hotelItems.map((item, i) => (
            <ImageCard
              key={i}
              src={item?.images[0]}
              alt=""
              onClick={() => {
                cardPressHandler(item);
              }}
            />
          ))}
        </ScrollArea>
        <PaginationWrapper>
          {hotelItems.length > 1 &&
            hotelItems.map((_, i) => (
              <Bar
                key={i}
                active={currentIndex === i}
                color={settings?.button_color}
              />
            ))}
        </PaginationWrapper>
      </BackGroundContainer>
    </Wrapper>
  );
}
